import React from 'react'
import HTag from '@/lib/HTag'
import CTA from '@/lib/CTA'
import ColumnItem from './ColumnItem'
import clsx from 'clsx'
import * as css from './ColumnList.module.css'

export default function ColumnList({ heading, columns, imageAspectRatio, items, stretchColumns, cta, blockId }) {
	return (
		<section id={blockId} className="section">
			<HTag className="h1 text-center" {...heading} />

			<div
				className={clsx(css.columns, columns < 2 && 'text-center', stretchColumns && 'full-width')}
				style={{ '--col': columns }}
			>
				{items?.map((item, key) => (
					<ColumnItem
						{...item}
						imageAspectRatio={imageAspectRatio}
						stretchColumns={stretchColumns}
						key={key}
					/>
				))}
			</div>
			<p className="text-center mt-5"><CTA {...cta} /></p>
		</section>
	)
}
